
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogsDetails]",
      function () {
        return require("private-next-pages/blog/[blogsDetails].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[blogsDetails]"])
      });
    }
  